import { module } from 'stereomodularjs';
import GLightbox from 'glightbox';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init(){
        let glightboxLinks = document.querySelectorAll('[data-module="GLightbox"]');
        let headerDiv = document.querySelector('.c-header');
        let customCloseDiv = document.querySelector('.js-glightbox-close');
        let customCloseCursor = document.querySelector('.js-glightbox-cursor-close');
        let customLightboxHTML = `<div data-lenis-prevent id="glightbox-body" class="glightbox-container">
                <div class="gloader visible"></div>
                <div class="goverlay"></div>
                <div class="gcontainer">
                <div id="glightbox-slider" class="gslider"></div>
                <button class="gnext gbtn" tabindex="0" aria-label="Image suivante"></button>
                <button class="gprev gbtn" tabindex="1" aria-label="Image précédente"></button>
                <button class="gclose gbtn" tabindex="2" aria-label="Fermer l'image superposée"></button>
            </div>
        </div>`;
        glightboxLinks.forEach(el => {
            el.setAttribute('data-glightbox', ".js-"+el.getAttribute('data-mid')+"-el");
            let elLinks = el.querySelectorAll('a');
            elLinks.forEach(elLink => {
                elLink.classList.add('js-'+el.getAttribute('data-mid')+'-el');
                elLink.classList.add('js-prevent');
            });
        });
        const glightbox = GLightbox({
            lightboxHTML: customLightboxHTML,
            skin: 'ilesq',
            selector: this.el.getAttribute('data-glightbox'),
            zoomable: false,
            // descPosition: 'bottom',
            // closeButton: false,
        });
        glightbox.on('open', () => {
            glightbox.elements[glightbox.elements.length - 1].instance.element.classList.add('is-glightbox-focus-back');
            headerDiv.classList.add('is-glightbox-active-visible');
            setTimeout(() => {
                customCloseCursor.classList.remove('-cursor-hidden');
            }, 650);
        })
        glightbox.on('close', () => {
            document.querySelector('.is-glightbox-focus-back').focus();
            document.querySelector('.is-glightbox-focus-back').classList.remove('is-glightbox-focus-back');
            headerDiv.classList.remove('is-glightbox-active-visible');
        })
        if(!customCloseDiv) return;
        // Trigger/simulate custom close
        customCloseDiv.addEventListener('click', function (e) {
            customCloseCursor.classList.add('-cursor-hidden');
            glightbox.close();
        }, false);
    }

    destroy(){
        let glightboxLinks = document.querySelectorAll('[data-module="GLightbox"]');
        glightboxLinks.forEach(el => {
            let elLinks = el.querySelectorAll('a');
            elLinks.forEach(elLink => {
                elLink.classList.remove('js-'+el.getAttribute('data-mid')+'-el');
                elLink.classList.remove('js-prevent');
            });
        });

        //Remove cursor hidden class
        let customCloseCursor = document.querySelector('.js-glightbox-cursor-close');
        customCloseCursor.classList.remove('-cursor-hidden');

        //Remove custom lightbox HTML
        let customLightboxBody = document.getElementById('glightbox-body');
        if(customLightboxBody)customLightboxBody.remove();
        //Remove class on html
        let html = document.querySelector('html');
        if(html.classList.contains('glightbox-open')) html.classList.remove('glightbox-open');
    }
}
